import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { ConfigProvider } from '@alicloud/console-components';
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * @param {Number} level
 */

export var getPriority = function getPriority(level) {
  return new Array(level).fill('&').join('');
};
/**
 * Checks if value is `null` or `undefined`
 * @param {*} value
 * @return {Boolean}
 */

export var isNil = function isNil(value) {
  return value == null;
};
export function GetFusionConfig(Wrapped) {
  var ConfifgConsumer = ConfigProvider.Consumer;

  var HOC = function HOC(props) {
    return /*#__PURE__*/React.createElement(ConfifgConsumer, null, function (context) {
      return /*#__PURE__*/React.createElement(Wrapped, _extends({}, props, {
        fusionConfig: context
      }));
    });
  };

  return HOC;
}